import React, { useState, useEffect } from "react";
import { Col, Row, Input, Form } from "antd";
import config from '../../config/form.json'
import { useRecoilValue } from "recoil";
import { orgmode } from "../../store/gloabalState";
import SectionHeading from "./section-headings";
import { getOrgsDetails } from "../../services/httpCalls";
import { IconButton } from "@mui/material";
import SourceIcon from "@mui/icons-material/Source";
import InitialInvoiceModal from "./initial-invoice-modal";

const InitialInvoice = ({
    handleChange
}) => {
    // * constants and binders
    const variableCharges = new RegExp(/^(\d+|\d*\.\d+)$/);

    // * initializing form 
    const [form] = Form.useForm();

    // * getting initial invoice config data
    const configData = config.initialInvoice[0]


    // * global states

    // * values
    const mode = useRecoilValue(orgmode)

    // * local states
    const [open,setOpen] = useState(false);
    const [orgDetails, setOrgDetails] = useState();

    useEffect(() => {
        let orgId = localStorage.getItem("orgId")
        getOrgsDetails(orgId)
            .then((res) => {
                if(res) {
                    setOrgDetails(res)
                    form.setFieldsValue({
                        nextInvoiceAmount: res?.nextInvoiceAmount,
                        nextInvoiceCurrencyCode: res?.nextInvoiceCurrencyCode,
                        nextInvoiceDueDate: res?.nextInvoiceDueDate.split('T')[0]
                    })
                }
            })
            .catch(err => console.log(err))
    },[])

    const handleClose =()=> {
        setOpen(false)
    }

    const renderField = (field, index) => {
        const { type, label, name, props} = field

        switch(type) {
            case 'Form.Item':
                return (
                    <React.Fragment>
                        <Form.Item
                            label={label}
                            name={name}
                            rules={field?.rules}
                            labelCol={field?.labelCol}
                            className={field?.className}
                            disabled={field?.disabled}
                        >      
                                {field?.children ? renderField(field?.children, 0) : null }
                        </Form.Item>
                        {field?.subFields ? field?.subFields.map((child, childIndex) => renderField(child, childIndex)) : null}
                    </React.Fragment>
                )
            case 'Input':
                return (
                    <Input
                        disabled={eval(props?.disabled)}
                        readOnly={eval(props?.readOnly)}
                        name={field?.name}
                        onKeyUp={eval(props?.onKeyUp)}
                        maxLength={props?.maxLength}
                     />
                );
            case 'SectionHeading':
                return (
                    <SectionHeading
                        style={field?.style}
                        level={field?.level}
                        heading={field?.heading}
                        Col={field?.Col}
                    />
                );
            case 'IconButton':
                return (
                    <IconButton
                        color="primary"
                        variant="contained"
                        onClick={() => setOpen(true)}
                    >
                        <SourceIcon
                            sx={{
                                color: "#2862FF",
                                fontSize: "30px",                            }}
                        />
                    </IconButton>
                )
            default :
                return null;
        }
    }

    return(
        <div>
        <InitialInvoiceModal
            open={open}
            handleClose={handleClose}
            orgDetails={orgDetails}
        />
        <Form
            {...configData.formConfig}
            form={form}
            className={ mode === 'view' }
            disabled={ mode === 'view' }
        >
            <Row gutter={[16,16]}>
                {configData.fields.map((field, index) => {
                    
                    // conditional render
                    const shouldRender = true;

                    return shouldRender && (
                        <Col key={index} span={field?.Col ? field.Col : 13}>
                            {renderField(field, index)}
                        </Col>
                    )
                })}
            </Row>
        </Form>
        </div>
    )
}

export default InitialInvoice;